// extracted by mini-css-extract-plugin
export default {"hotButton":"HotButton_hotButton__L1jAR","buttonLabel":"HotButton_buttonLabel__M0Pfo","buttonValue":"HotButton_buttonValue__5Oj1L"};